import { styled } from '@mui/material';

export const Emphasis = styled('span')({ color: '#a67c00', fontWeight: 'bold' });
